// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/
;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"a840b018e32f404e211fc32017a9d84b0cbc789d"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "/4.212.1.0";import { browserTracingIntegration, captureConsoleIntegration, init } from '@sentry/nextjs'

import { SENTRY_DSN, SENTRY_IGNORE_CONSOLE, SENTRY_TRACERATE } from './app/_constants/sentry'

const packageJson = require('./package.json')
const version = packageJson.version
const tagVersion = process.env.SENTRY_RELEASE?.split('@')[1]
const release = 'toad@' + (tagVersion || version)

function customSampleRateIntegration() {
    return {
        name: 'customSampleRateIntegration',
        processEvent(event) {
            const customSampleRate = event.tags?.sampleRate
            // Check for specific tag
            if (customSampleRate) {
                event.transaction_info = {
                    source: 'custom',
                }

                event.sdkProcessingMetadata = {
                    ...event.sdkProcessingMetadata,
                    sampleRate: customSampleRate,
                    dynamicSamplingContext: {
                        sample_rate: customSampleRate,
                    },
                }
            }

            return event
        },
    }
}

init({
    dsn: SENTRY_DSN,
    release,
    // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
    tracesSampleRate: SENTRY_TRACERATE,
    attachStacktrace: true,
    normalizeDepth: 10,
    skipOpenTelemetrySetup: true,
    // Setting this option to true will print useful information to the console while you're setting up Sentry.
    debug: false,
    tracePropagationTargets: [/^https:\/\/www\.khanoumi\.com\/api/],
    denyUrls: [/retargeting\.js/],

    integrations: [
        browserTracingIntegration({
            // disable automatic span creation
            instrumentNavigation: true,
            instrumentPageLoad: true,
        }),
        customSampleRateIntegration(),
        ...(SENTRY_IGNORE_CONSOLE === 'true'
            ? []
            : [
                  captureConsoleIntegration({
                      levels: ['error', 'warn', 'log', 'info'],
                  }),
              ]),
    ],
    beforeSend(event) {
        if (
            event.request?.url?.includes('api.mediaad.org') &&
            event.exception?.values?.some((value) => value.value === 'HTTP error: 0 -')
        ) {
            return null
        }

        if (
            event.exception?.values?.some((value) =>
                value.stacktrace?.frames?.some((frame) => frame.filename && frame.filename.includes('retargeting.js'))
            )
        ) {
            return null
        }

        return event
    },
})
